import React, { useState } from 'react';
import {
  Card,
  Button,
  Row,
  Col,
  Form,
  Collapse,
} from 'react-bootstrap';
import Selector from 'react-select';
import {
  FaSearch,
  FaChevronDown,
  FaChevronUp,
  FaFileExcel,
  FaEraser,
  FaCalendarAlt,
} from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import moment from 'moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import DateMask from '~/Components/DateMask';
import * as constants from '~/constant';
import { DropdownIndicator } from '~/Styles/reactSelectStyles';
import { selectStyles } from './selectStyles';
import SelectHierarquiaComercial from './SelectHierarquiaComercial';

const TIPOS_EMP_OPCOES = [
  { value: 'B', label: 'Bairro Planejado' },
  { value: 'L', label: 'Loteamento Fechado' },
  { value: 'V', label: 'Condomínio Vertical' },
  { value: 'H', label: 'Condomínio Horizontal' },
];

export default function FiltrosRelatorio({
  filtros,
  grupoEmpresas,
  gruposGe,
  empreendimentos,
  hierarquia,
  isLoading,
  isExporting,
  temDados,
  onFiltroChange,
  onSubmit,
  onLimpar,
  onExportarExcel,
}) {
  const [mostrarAvancados, setMostrarAvancados] = useState(false);
  const [openDatePickerInicial, setOpenDatePickerInicial] = useState(false);
  const [openDatePickerFinal, setOpenDatePickerFinal] = useState(false);

  const opcoesGE = (grupoEmpresas || []).map(g => ({
    value: g.codigo_grupo_empresa,
    label: g.apelido,
  }));

  const opcoesGrupoGE = (gruposGe || []).map(g => ({
    value: g.codigo,
    label: g.descricao,
  }));

  const opcoesEmpreendimentos = (empreendimentos || []).map(e => ({
    value: e.codigo_familia,
    label: e.nome_da_familia,
  }));

  const todosChecked = TIPOS_EMP_OPCOES.every(o =>
    filtros.tipos_empreendimento.includes(o.value)
  );

  const handleTipoEmpChange = (valor) => {
    const tipos = filtros.tipos_empreendimento;
    const novos = tipos.includes(valor)
      ? tipos.filter(t => t !== valor)
      : [...tipos, valor];
    onFiltroChange('tipos_empreendimento', novos);
  };

  const handleTodosChange = () => {
    if (todosChecked) {
      onFiltroChange('tipos_empreendimento', []);
    } else {
      onFiltroChange('tipos_empreendimento', ['B', 'L', 'V', 'H']);
    }
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', fontWeight: 'bold' }}>
        Filtros
      </Card.Header>
      <Card.Body>
        {/* Filtros principais */}
        <Row className="mb-2">
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>G.E.:</Form.Label>
              <Selector
                styles={selectStyles}
                components={{ DropdownIndicator }}
                options={opcoesGE}
                isClearable
                placeholder="Selecione o G.E...."
                value={opcoesGE.find(o => o.value === filtros.codigo_grupo_empresa) || null}
                onChange={opt => onFiltroChange('codigo_grupo_empresa', opt ? opt.value : null)}
                noOptionsMessage={() => 'Nenhum G.E. encontrado'}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Grupo GE:</Form.Label>
              <Selector
                styles={selectStyles}
                components={{ DropdownIndicator }}
                options={opcoesGrupoGE}
                isClearable
                placeholder="Selecione o Grupo GE..."
                value={opcoesGrupoGE.find(o => o.value === filtros.codigo_grupo_ge) || null}
                onChange={opt => onFiltroChange('codigo_grupo_ge', opt ? opt.value : null)}
                noOptionsMessage={() => 'Nenhum Grupo GE encontrado'}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label>Empreendimentos:</Form.Label>
              <Selector
                styles={selectStyles}
                components={{ DropdownIndicator }}
                options={opcoesEmpreendimentos}
                isMulti
                isClearable
                placeholder="Todos os empreendimentos..."
                value={opcoesEmpreendimentos.filter(o =>
                  filtros.empreendimentos_selecionados.includes(o.value)
                )}
                onChange={opts =>
                  onFiltroChange(
                    'empreendimentos_selecionados',
                    opts ? opts.map(o => o.value) : []
                  )
                }
                noOptionsMessage={() => 'Selecione G.E. ou Grupo GE primeiro'}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Data Inicial:</Form.Label>
              <DateMask allowEmpty>
                {() => (
                  <div className="position-relative">
                    <MaskedInput
                      name="data_inicial"
                      type="tel"
                      guide={false}
                      className="form-control"
                      placeholder="Ex.: 01/01/2019"
                      mask={constants.MASK_DATE}
                      value={filtros.data_inicial}
                      onChange={e => onFiltroChange('data_inicial', e.target.value)}
                      style={{ paddingRight: '35px' }}
                    />
                    <div
                      className="position-absolute d-flex align-items-center"
                      style={{
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }}
                    >
                      <FaCalendarAlt
                        className="text-secondary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setOpenDatePickerInicial(true)}
                      />
                    </div>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br">
                      <DatePicker
                        open={openDatePickerInicial}
                        onOpen={() => setOpenDatePickerInicial(true)}
                        onClose={() => setOpenDatePickerInicial(false)}
                        value={
                          filtros.data_inicial
                            ? moment(filtros.data_inicial, 'DD/MM/YYYY')
                            : null
                        }
                        onChange={date => {
                          onFiltroChange(
                            'data_inicial',
                            date ? date.format('DD/MM/YYYY') : ''
                          );
                          setOpenDatePickerInicial(false);
                        }}
                        format="DD/MM/YYYY"
                        TextFieldComponent={() => null}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                )}
              </DateMask>
            </Form.Group>
          </Col>
          <Col xs={12} md={3}>
            <Form.Group>
              <Form.Label>Data Final:</Form.Label>
              <DateMask allowEmpty>
                {() => (
                  <div className="position-relative">
                    <MaskedInput
                      name="data_final"
                      type="tel"
                      guide={false}
                      className="form-control"
                      placeholder="Ex.: 01/01/2019"
                      mask={constants.MASK_DATE}
                      value={filtros.data_final}
                      onChange={e => onFiltroChange('data_final', e.target.value)}
                      style={{ paddingRight: '35px' }}
                    />
                    <div
                      className="position-absolute d-flex align-items-center"
                      style={{
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }}
                    >
                      <FaCalendarAlt
                        className="text-secondary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setOpenDatePickerFinal(true)}
                      />
                    </div>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br">
                      <DatePicker
                        open={openDatePickerFinal}
                        onOpen={() => setOpenDatePickerFinal(true)}
                        onClose={() => setOpenDatePickerFinal(false)}
                        value={
                          filtros.data_final
                            ? moment(filtros.data_final, 'DD/MM/YYYY')
                            : null
                        }
                        onChange={date => {
                          onFiltroChange(
                            'data_final',
                            date ? date.format('DD/MM/YYYY') : ''
                          );
                          setOpenDatePickerFinal(false);
                        }}
                        format="DD/MM/YYYY"
                        TextFieldComponent={() => null}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                )}
              </DateMask>
            </Form.Group>
          </Col>
        </Row>

        {/* Filtros Avançados */}
        <Row className="mb-2">
          <Col xs={12}>
            <Button
              variant="link"
              className="p-0 text-secondary"
              onClick={() => setMostrarAvancados(v => !v)}
            >
              {mostrarAvancados ? <FaChevronUp /> : <FaChevronDown />}{' '}
              {mostrarAvancados ? 'Ocultar filtros avançados' : 'Mostrar filtros avançados'}
            </Button>
          </Col>
        </Row>

        <Collapse in={mostrarAvancados}>
          <div>
            <SelectHierarquiaComercial
              grupoEmpresas={grupoEmpresas}
              hierarquia={hierarquia}
              filtros={filtros}
              onFiltroChange={onFiltroChange}
            />

            <Row className="mb-2">
              <Col xs={12} md={4}>
                <Form.Group>
                  <Form.Label>Período referente:</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      type="radio"
                      label="Data da efetivação da venda"
                      checked={filtros.periodo_referente === 'E'}
                      onChange={() => onFiltroChange('periodo_referente', 'E')}
                      id="radio-efetivacao"
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="Data da assinatura do contrato"
                      checked={filtros.periodo_referente === 'P'}
                      onChange={() => onFiltroChange('periodo_referente', 'P')}
                      id="radio-proposta"
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group>
                  <Form.Label>Gerencial:</Form.Label>
                  <div>
                    <Form.Check
                      inline
                      type="radio"
                      label="Ambos"
                      checked={filtros.filtro_gerencial === 'A'}
                      onChange={() => onFiltroChange('filtro_gerencial', 'A')}
                      id="radio-gerencial-ambos"
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="Sim"
                      checked={filtros.filtro_gerencial === 'S'}
                      onChange={() => onFiltroChange('filtro_gerencial', 'S')}
                      id="radio-gerencial-sim"
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="Não"
                      checked={filtros.filtro_gerencial === 'N'}
                      onChange={() => onFiltroChange('filtro_gerencial', 'N')}
                      id="radio-gerencial-nao"
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group>
                  <Form.Label>VV:</Form.Label>
                  <div>
                    <Form.Check
                      type="radio"
                      label="Valor digitado na Pré-Venda (Contrato+Valor Imob) (VV)"
                      checked={filtros.tipo_vv === 'S'}
                      onChange={() => onFiltroChange('tipo_vv', 'S')}
                      id="radio-vv-original"
                    />
                    <Form.Check
                      type="radio"
                      label="Valor Presente do total à prazo (Contrato) (VP)"
                      checked={filtros.tipo_vv === 'C'}
                      onChange={() => onFiltroChange('tipo_vv', 'C')}
                      id="radio-vv-calculado"
                    />
                    <Form.Check
                      type="radio"
                      label="Valor digitado na Pré-Venda - Valor Imob (VGV)"
                      checked={filtros.tipo_vv === 'P'}
                      onChange={() => onFiltroChange('tipo_vv', 'P')}
                      id="radio-vv-vgv"
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col xs={12} md={6}>
                <Form.Label>Tipos de Empreendimento:</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="checkbox"
                    label="Todos"
                    checked={todosChecked}
                    onChange={handleTodosChange}
                    id="chk-todos"
                  />
                  {TIPOS_EMP_OPCOES.map(opt => (
                    <Form.Check
                      inline
                      key={opt.value}
                      type="checkbox"
                      label={opt.label}
                      checked={filtros.tipos_empreendimento.includes(opt.value)}
                      onChange={() => handleTipoEmpChange(opt.value)}
                      id={`chk-tipo-${opt.value}`}
                    />
                  ))}
                </div>
              </Col>
              <Col xs={12} md={6}>
                <Form.Label>Opções:</Form.Label>
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Não listar transferências"
                    checked={filtros.excluir_transferencias === 'S'}
                    onChange={e =>
                      onFiltroChange('excluir_transferencias', e.target.checked ? 'S' : 'N')
                    }
                    id="chk-transferencias"
                  />
                  <Form.Check
                    type="checkbox"
                    label="Listar histórico do Imóvel"
                    checked={filtros.listar_historico === 'S'}
                    onChange={e =>
                      onFiltroChange('listar_historico', e.target.checked ? 'S' : 'N')
                    }
                    id="chk-historico"
                  />
                  <Form.Check
                    type="checkbox"
                    label="Não listar sinal parceiro"
                    checked={filtros.ocultar_sinal_parceiro === 'S'}
                    onChange={e =>
                      onFiltroChange('ocultar_sinal_parceiro', e.target.checked ? 'S' : 'N')
                    }
                    id="chk-sinal-parceiro"
                  />
                  <Form.Check
                    type="checkbox"
                    label="Considerar somente Int. Vendas"
                    checked={filtros.somente_int_vendas === 'S'}
                    onChange={e =>
                      onFiltroChange('somente_int_vendas', e.target.checked ? 'S' : 'N')
                    }
                    id="chk-int-vendas"
                  />
                  <Form.Check
                    type="checkbox"
                    label="Considerar vendas do responsável do empreendimento"
                    checked={filtros.considerar_responsavel === 'S'}
                    onChange={e =>
                      onFiltroChange('considerar_responsavel', e.target.checked ? 'S' : 'N')
                    }
                    id="chk-responsavel"
                  />
                  <Form.Check
                    type="checkbox"
                    label="Filtrar rescisão pela data de lançamento"
                    checked={filtros.filtrar_rescisao_data === 'S'}
                    onChange={e =>
                      onFiltroChange('filtrar_rescisao_data', e.target.checked ? 'S' : 'N')
                    }
                    id="chk-rescisao-data"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Collapse>

        {/* Botões */}
        <Row className="mt-3">
          <Col xs={12} md="auto">
            <Button
              variant="primary"
              onClick={onSubmit}
              disabled={isLoading}
            >
              <FaSearch /> Gerar Relatório
            </Button>
          </Col>
          <Col xs={12} md="auto">
            <Button
              variant="secondary"
              onClick={onLimpar}
              disabled={isLoading}
            >
              <FaEraser /> Limpar Filtros
            </Button>
          </Col>
          {temDados && (
            <Col xs={12} md="auto">
              <Button
                variant="success"
                onClick={onExportarExcel}
                disabled={isExporting}
              >
                <FaFileExcel /> {isExporting ? 'Exportando...' : 'Exportar Excel'}
              </Button>
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
}
